import React from 'react';
import Icon from '@material-ui/core/Icon';
import styled from 'styled-components';
import FooterLink from './FooterLink';

interface Props {
  className: string;
  classes?: { [key: string]: string };
  href: string;
}

const StyledIcon = styled(Icon)`
  vertical-align: middle;
  border-style: none;
`;

const FabIconLink = ({ className, classes, href }: Props) => (
  <FooterLink href={href}>
    <StyledIcon className={className} classes={classes} />
  </FooterLink>
);

export default FabIconLink;
